import {
  UtilityType,
  UtilityTypeOrAll,
} from 'switch-shared/modules/crud/utility/utility.enums';

export const ALL_SELECTION_ID = 'All';

export const ALL_UTILITY_SELECTION_ID = 'all';

export function isAllSelection(
  value?: string | null
): value is typeof ALL_SELECTION_ID {
  return value?.toLowerCase() === ALL_SELECTION_ID.toLowerCase();
}

/**
 * Check if the utility selection is the "all" sentinel.
 * Use this when you need to know "is this the combined/all view?".
 */
export function isAllUtilitySelection(
  value?: UtilityTypeOrAll | null
): value is typeof ALL_UTILITY_SELECTION_ID {
  return value === ALL_UTILITY_SELECTION_ID;
}

export function toScopedId(value?: string | null): string | undefined {
  if (!value || isAllSelection(value)) {
    return undefined;
  }

  return value;
}

/**
 * Strip the "all" sentinel and return a concrete UtilityType.
 * Returns undefined when the value is "all", null, or undefined.
 */
export function toConcreteUtilityType(
  value?: UtilityTypeOrAll | null
): UtilityType | undefined {
  if (!value || isAllUtilitySelection(value)) {
    return undefined;
  }

  return value;
}

export function hasConcreteSelection(value?: string | null): boolean {
  return toScopedId(value) !== undefined;
}

/**
 * Check if the value is a concrete UtilityType (not the "all" sentinel).
 * Prefer this over `!isAllUtilitySelection(...)` — it provides type
 * narrowing and validates the value is a real enum member.
 */
export function isUtilityType(
  utilityType: UtilityType | UtilityTypeOrAll
): utilityType is UtilityType {
  return !isAllUtilitySelection(utilityType);
}
